import React from 'react';
import { Icon } from '@shakkerai/components';
import { translate } from '@shakkerai/util-i18n';

const FilterPic = React.memo(({ filters, onSubmit, sortOptions, setFilters, initFlag }) => {
  const handleInputKeyword = (e) => {
    setFilters({ ...filters, keyword: e.target.value });
  };

  const handleClearKeyword = (e) => {
    const currState = {
      keyword: '',
      sortType: initFlag ? 'case' : undefined,
      flag: false,
    };
    setFilters(currState);
    onSubmit(currState);
    e.stopPropagation();
  };

  const handkeKeyDown = (e) => {
    if (e.key === 'Enter') {
      const curState = { ...filters, flag: true, sortType: undefined };
      setFilters(curState);
      onSubmit(curState);
    }
  };
  const sortTypeChange = (sortType) => {
    if (filters.flag) return;
    const curState = {
      ...filters,
      sortType,
    };
    setFilters(curState);
    onSubmit(curState);
  };
  return (
    <>
      <div className="flex items-center">
        {sortOptions && initFlag && (
          <div className="flex h-[30px] ml-4 p-0.5 bg-[#f4f6f8] rounded">
            {sortOptions.map((item) => (
              <button
                key={item.value}
                disabled={item.value === filters.sortType}
                onClick={() => sortTypeChange(item.value)}
                className="h-[26px] px-3 rounded-sm text-xs text-[#ADADAD] disabled:bg-white disabled:text-[#2d2d2d]"
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
        <div className="mx-4 relative flex items-center min-w-[140px] flex-1 h-[30px] px-3 bg-[#f4f6f8] border border-transparent focus-within:border-primary rounded overflow-hidden">
          <Icon className="shk-danchuang-sousuo" fontSize={16} color="#ADADAD" />
          <input
            maxLength={16}
            value={filters.keyword}
            placeholder={translate('common_search')}
            className="flex-1 mx-2 bg-transparent text-[13px]"
            onKeyDown={handkeKeyDown}
            onChange={handleInputKeyword}
          />
          {filters.flag && (
            <button
              onClick={handleClearKeyword}
              className="absolute flex items-center justify-center z-[2] right-[5px] w-[14px] h-[14px] rounded-full bg-black/20"
            >
              <Icon className="shk-prompt-lora-guanbi scale-50" fontSize={12} color="#fff" />
            </button>
          )}
        </div>
      </div>
    </>
  );
});

export default FilterPic;
